import $api from "@/frontend/shared/api/axios";

// TODO: should probably be renamed to deletePortfolioCompany
// for clarity since company and portfolioCompany are diff - J
export function deleteCompany(id: number) {
  return $api.delete(`/portfolio-companies/${id}`);
}
